<template>
    <section class="driver-section">
        <header class="driver-section__header">
            <p class="driver-section__title">
                {{ $t("driverProfile.bankAccount") }}
            </p>
        </header>

        <div class="driver-section__card">
            <div class="driver-section__grid driver-section__grid--triple">
                <div class="driver-section__field">
                    <label class="driver-section__label">
                        {{ $t("driverProfile.bankName") }}
                    </label>
                    <a-select
                        v-model.number="model.bank_id"
                        :options="bankProfileList"
                        class="tw-w-full"
                        :placeholder="$t('driverProfile.bankName')"
                        allowClear
                    ></a-select>
                    <div
                        class="driver-section__error"
                        v-if="errors.has('bank_id')"
                    >
                        {{ errors.first("bank_id") }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label">
                        {{ $t("driverProfile.accountNumber") }}
                    </label>
                    <input
                        v-model="model.bank_acc_number"
                        type="text"
                        class="form-control"
                        :placeholder="$t('driverProfile.accountNumber')"
                        :class="{ 'is-invalid': errors.has('bank_acc_number') }"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('bank_acc_number')"
                    >
                        {{ errors.first("bank_acc_number") }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label">
                        {{ $t("driverProfile.accountName") }}
                    </label>
                    <input
                        v-model="model.bank_acc_name"
                        type="text"
                        class="form-control"
                        :placeholder="$t('driverProfile.accountName')"
                        :class="{ 'is-invalid': errors.has('bank_acc_name') }"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('bank_acc_name')"
                    >
                        {{ errors.first("bank_acc_name") }}
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from 'vuex';

export default {
    name: "bankAccount",
    props: ["value", "validate"],
    data() {
        return {
            errors: new Errors(),
            model: {}
        };
    },
    created() {
        this.model = this.value;
    },
    computed: {
        ...mapState("driver/driverProfile", ['formModels']),
        bankProfileList() {
            if (!this.formModels.bankProfile) return [];

            return this.formModels.bankProfile.map(el => ({
                value: el.bank_id,
                label: el.bank_name
            }));
        }
    },
    watch: {
        validate: function(error) {
            this.errors = new Errors(error.errors);
        }
    }
};
</script>

<style scoped>
.driver-section__header {
    margin-bottom: 10px;
}

.driver-section__title {
    margin: 0;
    color: #8ea0b4;
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    text-decoration: underline;
    text-underline-offset: 3px;
}

.driver-section__card {
    border: 1px solid #dfe6ee;
    border-radius: 10px;
    background: #fff;
    padding: 14px;
}

.driver-section__grid {
    display: grid;
    gap: 14px 16px;
}

.driver-section__grid--triple {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.driver-section__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.driver-section__label {
    margin: 0;
    color: #3f4d5d;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.35;
}

.driver-section__error {
    color: #dc2626;
    font-size: 12px;
}

@media (max-width: 991px) {
    .driver-section__grid--triple {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 767px) {
    .driver-section__card {
        padding: 12px;
    }

    .driver-section__grid--triple {
        grid-template-columns: 1fr;
    }
}
</style>
